import axios from "axios";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap";
import * as Yup from "yup";
import { default as logoDark, default as logoLight } from "../../assets/images/Aditya.png";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const SendOtp = () => {
  const navigate = useNavigate();
  document.title = "Send OTP | Forget Password";

  /** FORM VALIDATION */
  const validation = useFormik({
    initialValues: {
      roll_no: "",
    },
    validationSchema: Yup.object({
      roll_no: Yup.string().required("Please enter your Roll Number"),
    }),
    onSubmit: async (values) => {
      await handleSendOtp(values);
    },
  });

  /** SEND OTP API */
  const handleSendOtp = async (values) => {
    try {
      const response = await axios.post(`${backendUrl}validate-roll-number`, {
        roll_no: values.roll_no,
      });

      alert("OTP sent successfully!");

      navigate("/verify-otp", {
        state: { roll_no: values.roll_no },
      });
    } catch (err) {
      console.error("API Error:", err);
      alert("Invalid Roll Number or something went wrong!");
    }
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <CardBody className="pt-0">
                <h3 className="text-center mt-5 mb-4">
                  <Link to="/" className="d-block auth-logo">
                    <img
                      src={logoDark}
                      alt=""
                      height="30"
                      className="auth-logo-dark"
                    />
                    <img
                      src={logoLight}
                      alt=""
                      height="30"
                      className="auth-logo-light"
                    />
                  </Link>
                </h3>

                <div className="p-3">
                  <h4 className="text-muted font-size-18 mb-3 text-center">
                    OTP Verification
                  </h4>

                  <form className="form-horizontal mt-4" onSubmit={validation.handleSubmit}>
                    <div className="mb-3">
                      <Label htmlFor="roll_no">Enter Your Employee Id</Label>
                      <Input
                        name="roll_no"
                        placeholder="Enter Employee Id"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.roll_no}
                        invalid={
                          validation.touched.roll_no &&
                            validation.errors.roll_no
                            ? true
                            : false
                        }
                      />
                      {validation.touched.roll_no &&
                        validation.errors.roll_no && (
                          <FormFeedback type="invalid">
                            {validation.errors.roll_no}
                          </FormFeedback>
                        )}
                    </div>

                    <Row className="mb-3">
                      <div className="col-12 text-end">
                        <button className="btn btn-primary w-md" type="submit">
                          Send OTP
                        </button>
                      </div>
                    </Row>
                  </form>
                </div>
              </CardBody>
            </Card>

            <div className="mt-5 text-center">
              <p>
                Remember it?{" "}
                <Link to="/login" className="text-primary">
                  Sign In Here
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SendOtp;
